import React, {useMemo, useState} from 'react';
import { useFirestore } from 'reactfire';
import SingleFavAdd from './singleFavAdd';
import {message} from 'antd'

const ManageFavourites = (props) => {
    
    const firestore = useFirestore();
    const query_fav = firestore.collection('Favourite_Investigation');
    const [favLIst , setFavList] = useState(props.favRecords || []);


    useMemo(() => {
        // componentWillReceiveProps
        setFavList(props.favRecords);
      },[props]);
     

    const onFavListUpdated = () => {
        props.refreshFavList();
    }

    const onFavListDeleteChild = (id) => {
        query_fav.doc(id).delete().then((res) => {
            props.refreshFavList();
            // getAllRecords();
            message.success('Favorite list deleted');
        });
    }

    return (
        <div>
            <h2>Favourites Lists</h2>
            <ul className='favlist'>
                {favLIst && favLIst.map((item) => {
                    return <SingleFavAdd currentFav={item} key={item.id} onFavListDelete={onFavListDeleteChild} listUpdated={onFavListUpdated} />
                })}
            </ul>
        </div>
    );
}

export default ManageFavourites;
